const OrderConstant = {
    ORDER_STATUS_WSG_WAIT: 'pending_approval', // WSG承認待ち
    ORDER_STATUS_PROPOSAL: 'proposal', // 提案中
    ORDER_STATUS_CANCEL: 'cancel', // キャンセル
    ORDER_STATUS_WSG_APPROVAL: 'approved', // WSG承認済
    ORDER_STATUS_CUSTOMER_PLACED: 'customer_placed', // 顧客発注済
    ORDER_STATUS_FIXED: 'fixed', // 最終確定
    ORDER_STATUS_PAYMENT_WAIT: 'payment_waiting', // 入金待ち
    ORDER_STATUS_DELIVERY_PENDING: 'delivery_pending', // 発送待ち
    ORDER_STATUS_DELIVERY_COMPLETE: 'delivered', // 発送済み
    ORDER_STATUS_COMPLETE: 'order_complete', // 完了

    RENTAL_PERIOD_DEFAULT: '4_NIGHTS_5_DATE', // ４泊５日
    RENTAL_PERIOD_11_NIGHTS_12_DATE: '11_NIGHTS_12_DATE', // 11泊12日
    RENTAL_PERIOD_ONE_MONTH: 'ONE_MONTH', // 1ヶ月
    RENTAL_PERIOD_THREE_MONTH: 'THREE_MONTH', // 3ヶ月
    RENTAL_PERIOD_SIX_MONTH: 'SIX_MONTH', // 6ヶ月
    RENTAL_PERIOD_TWELVE_MONTH: 'TWELVE_MONTH', // 12ヶ月
    RENTAL_PERIOD_TWENTY_FOUR_MONTH: 'TWENTY_FOUR_MONTH', // 24ヶ月
    RENTAL_PERIOD_THIRTY_SIX_MONTH: 'THIRTY_SIX_MONTH', // 36ヶ月

    PDF_PURCHASE_ORDER: 'purchase_order', // 発注書
    PDF_PRODUCT_GUIDE: 'product_guide', // 商品明細書
    PDF_QUOTATION: 'quotation', // 発注書
    PDF_INVOICE: 'invoice', // 請求書
    PDF_RECEIPT: 'receipt', // 請求書
    PDF_CONFIRMATION: 'confirmation', // 納品・返却確認書
    PDF_USER_DETAIL: 'user_detail', // 一般ユーザー明細
    PDF_PRE_CONTRACT_PERSON: 'pre_contract_person', // 契約前法人明細
}

export const ORDER_STATUS_LIST = [
    { value: OrderConstant.ORDER_STATUS_WSG_WAIT, name: 'WSG承認待ち' },
    { value: OrderConstant.ORDER_STATUS_PROPOSAL, name: '提案中' },
    { value: OrderConstant.ORDER_STATUS_WSG_APPROVAL, name: 'WSG承認済' },
    { value: OrderConstant.ORDER_STATUS_CUSTOMER_PLACED, name: '顧客発注済' },
    { value: OrderConstant.ORDER_STATUS_FIXED, name: '最終確定' },
    { value: OrderConstant.ORDER_STATUS_PAYMENT_WAIT, name: '入金待ち' },
    { value: OrderConstant.ORDER_STATUS_DELIVERY_PENDING, name: '発送待ち' },
    { value: OrderConstant.ORDER_STATUS_DELIVERY_COMPLETE, name: '発送済み' },
    { value: OrderConstant.ORDER_STATUS_COMPLETE, name: '完了' },
    { value: OrderConstant.ORDER_STATUS_CANCEL, name: 'キャンセル' },
]

export const USER_ORDER_ORDER_STATUS_LIST = [
    { value: OrderConstant.ORDER_STATUS_WSG_WAIT, name: 'ご注文内容確認中' },
    { value: OrderConstant.ORDER_STATUS_PROPOSAL, name: 'ご注文内容確認中' },
    { value: OrderConstant.ORDER_STATUS_CANCEL, name: 'キャンセル' },
    { value: OrderConstant.ORDER_STATUS_WSG_APPROVAL, name: '仮予約中'},
    { value: OrderConstant.ORDER_STATUS_CUSTOMER_PLACED, name: '本予約完了' },
    { value: OrderConstant.ORDER_STATUS_FIXED, name: 'ご注文内容確定／出荷準備中' },
    { value: OrderConstant.ORDER_STATUS_PAYMENT_WAIT, name: 'ご入金待ち' },
    { value: OrderConstant.ORDER_STATUS_DELIVERY_PENDING, name: 'ご入金済み／発送準備中' },
    { value: OrderConstant.ORDER_STATUS_DELIVERY_COMPLETE, name: '商品発送済み' },
    { value: OrderConstant.ORDER_STATUS_COMPLETE, name: 'ご返却完了' },
]

export const RENTAL_PERIOD_LIST = [
    { value: OrderConstant.RENTAL_PERIOD_DEFAULT, name: '4泊5日', rate: 1 },
    { value: OrderConstant.RENTAL_PERIOD_11_NIGHTS_12_DATE, name: '11泊12日', rate: 2 },
    { value: OrderConstant.RENTAL_PERIOD_ONE_MONTH, name: '1ヶ月', rate: 2.5 },
    { value: OrderConstant.RENTAL_PERIOD_THREE_MONTH, name: '3ヶ月', rate: 4 },
    { value: OrderConstant.RENTAL_PERIOD_SIX_MONTH, name: '6ヶ月', rate: 5 },
    { value: OrderConstant.RENTAL_PERIOD_TWELVE_MONTH, name: '12ヶ月', rate: 6 },
    { value: OrderConstant.RENTAL_PERIOD_TWENTY_FOUR_MONTH, name: '24ヶ月', rate: 8 },
    { value: OrderConstant.RENTAL_PERIOD_THIRTY_SIX_MONTH, name: '36ヶ月', rate: 8 },
]
export default OrderConstant



// WEBPACK FOOTER //
// ./resources/assets/js/const/OrderConstant.js